import _regeneratorRuntime from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime";
import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { useState, useRef, useCallback, useEffect } from 'react';
function getFullscreenElement() {
  var _document = window.document;
  var fullscreenElement = _document.fullscreenElement || _document.webkitFullscreenElement || _document.mozFullScreenElement || _document.msFullscreenElement;
  return fullscreenElement;
}
function exitFullscreen() {
  return _exitFullscreen.apply(this, arguments);
}
function _exitFullscreen() {
  _exitFullscreen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _document;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _document = window.document;
          if (!(typeof _document.exitFullscreen === "function")) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", _document.exitFullscreen());
        case 3:
          if (!(typeof _document.msExitFullscreen === "function")) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", _document.msExitFullscreen());
        case 5:
          if (!(typeof _document.webkitExitFullscreen === "function")) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", _document.webkitExitFullscreen());
        case 7:
          if (!(typeof _document.mozCancelFullScreen === "function")) {
            _context2.next = 9;
            break;
          }
          return _context2.abrupt("return", _document.mozCancelFullScreen());
        case 9:
          return _context2.abrupt("return", null);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _exitFullscreen.apply(this, arguments);
}
function enterFullScreen(_x) {
  return _enterFullScreen.apply(this, arguments);
}
function _enterFullScreen() {
  _enterFullScreen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(element) {
    var _a, _b, _c, _d, _e, _element;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _element = element;
          return _context3.abrupt("return", ((_a = _element.requestFullscreen) == null ? void 0 : _a.call(_element)) || ((_b = _element.msRequestFullscreen) == null ? void 0 : _b.call(_element)) || ((_c = _element.webkitEnterFullscreen) == null ? void 0 : _c.call(_element)) || ((_d = _element.webkitRequestFullscreen) == null ? void 0 : _d.call(_element)) || ((_e = _element.mozRequestFullscreen) == null ? void 0 : _e.call(_element)));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _enterFullScreen.apply(this, arguments);
}
var prefixes = ["", "webkit", "moz", "ms"];
function addEvents(element, _ref2) {
  var onFullScreen = _ref2.onFullScreen,
    onError = _ref2.onError;
  prefixes.forEach(function (prefix) {
    element.addEventListener("".concat(prefix, "fullscreenchange"), onFullScreen);
    element.addEventListener("".concat(prefix, "fullscreenerror"), onError);
  });
  return function () {
    prefixes.forEach(function (prefix) {
      element.removeEventListener("".concat(prefix, "fullscreenchange"), onFullScreen);
      element.removeEventListener("".concat(prefix, "fullscreenerror"), onError);
    });
  };
}
function useFullscreen() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fullscreen = _useState2[0],
    setFullscreen = _useState2[1];
  var _ref = useRef();
  var handleFullscreenChange = useCallback(function (event) {
    setFullscreen(event.target === getFullscreenElement());
  }, [setFullscreen]);
  var handleFullscreenError = useCallback(function (event) {
    setFullscreen(false);
    console.error("[@mantine/hooks] use-fullscreen: Error attempting full-screen mode method: ".concat(event, " (").concat(event.target, ")"));
  }, [setFullscreen]);
  var toggle = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (getFullscreenElement()) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return enterFullScreen(_ref.current);
        case 3:
          _context.next = 7;
          break;
        case 5:
          _context.next = 7;
          return exitFullscreen();
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  var ref = useCallback(function (element) {
    if (element === null) {
      _ref.current = window.document.documentElement;
    } else {
      _ref.current = element;
    }
  }, []);
  useEffect(function () {
    if (!_ref.current && window.document) {
      _ref.current = window.document.documentElement;
      return addEvents(_ref.current, {
        onFullScreen: handleFullscreenChange,
        onError: handleFullscreenError
      });
    }
    if (_ref.current) {
      return addEvents(_ref.current, {
        onFullScreen: handleFullscreenChange,
        onError: handleFullscreenError
      });
    }
    return void 0;
  }, []);
  return {
    ref: ref,
    toggle: toggle,
    fullscreen: fullscreen
  };
}
export { useFullscreen };